import React from 'react'
import styled from 'styled-components'

import { theme } from '../../../theme'

const Container = styled.div`
  padding: 1.5rem;
`

const LogoContainer = styled.div`
  margin-bottom: 1rem;
  text-align: center;
`

const Logo = styled.img<{ size: number }>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  margin: 0 auto;
`

const HeaderContainer = styled.div`
  margin-bottom: 1.5rem;
  text-align: center;
`

const Title = styled.h1`
  font-family: ${theme.fonts.itcGothicPro};
  font-size: ${theme.fontSize['2xl']};
  color: ${theme.colors.altovita};
  margin-bottom: 0.5rem;
`

const Subtitle = styled.p`
  font-size: ${theme.fontSize.base};
  font-weight: ${theme.fontWeight.light};
  color: ${theme.colors.greyText};
  line-height: normal;
`

type LayoutProps = {
  children: React.ReactNode
  title?: string
  subtitle?: string
  showLogo?: boolean
  largeLogo?: boolean
  className?: string
}

export const Layout = ({
  children,
  title,
  subtitle,
  showLogo = true,
  largeLogo,
  className = '',
}: LayoutProps) => (
  <Container className={className}>
    {showLogo && (
      <LogoContainer>
        <Logo
          alt="AltoVita"
          src="../../assets/logo-filled.png"
          title="AltoVita"
          size={largeLogo ? 60 : 32}
        />
      </LogoContainer>
    )}

    {(title || subtitle) && (
      <HeaderContainer>
        {title && <Title>{title}</Title>}
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </HeaderContainer>
    )}

    {children}
  </Container>
)
